import { computed } from "vue";
import { formatCompactNumber } from "@/src/utils/analyticsChartUtils.js";

export const useBarChartOptions = ({
  baseOptions,
  isDark,
  textColor,
  gridColor,
  labelColor,
  categories,
  xAxisLabel,
  yAxisLabel,
  isHorizontal,
  getFormattedValue,
  decimalPlaces,
}) => {
  return computed(() => ({
    ...baseOptions.value,
    dataLabels: { enabled: false },
    stroke: {
      width: 2,
      colors: baseOptions.value.colors,
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: isDark.value ? "dark" : "light",
        type: "vertical",
        shadeIntensity: 0.1,
        inverseColors: !isDark.value,
        opacityFrom: 0.5,
        opacityTo: 0.2,
        stops: [0, 80],
      },
    },
    plotOptions: {
      bar: {
        horizontal: isHorizontal.value,
        borderRadius: 4,
        columnWidth: "55%",
        barHeight: "55%",
        borderWidth: 2,
        strokeWidth: 2,
        borderRadiusApplication: "end",
        distributed: false,
      },
    },
    xaxis: {
      categories: categories.value,
      title: {
        text: xAxisLabel.value,
        style: {
          color: labelColor,
          fontSize: "12px",
          fontFamily: "Proxima Nova, sans-serif",
          fontWeight: 500,
          cssClass: "primary_color",
        },
      },
      labels: {
        style: {
          colors: textColor,
          fontSize: "11px",
          fontFamily: "Proxima Nova, sans-serif",
        },
        rotate: -45,
        rotateAlways: !isHorizontal.value && categories.value.length > 6,
      },
      axisBorder: { show: true, color: gridColor },
      axisTicks: { show: false },
    },
    yaxis: {
      title: {
        text: yAxisLabel.value,
        style: {
          color: labelColor,
          fontSize: "12px",
          fontFamily: "Proxima Nova, sans-serif",
          fontWeight: 500,
          cssClass: "primary_color",
        },
      },
      labels: {
        style: {
          colors: textColor,
          fontSize: "11px",
          fontFamily: "Proxima Nova, sans-serif",
        },
        formatter: (val) => formatCompactNumber(val, decimalPlaces?.value),
      },
    },
    tooltip: {
      ...baseOptions.value.tooltip,
      y: {
        formatter: (val, opts) =>
          getFormattedValue(opts.seriesIndex, opts.dataPointIndex),
      },
    },
  }));
};

